var spanishTranslation = {
    translations: {
        common: {
            goBack: "Regresar",
            showMore: "Mostrar más",
            showLess: "Mostrar menos",
        },
        a11y: {
            skipToContent: "Saltar al contenido principal",
            helpAbout: "Ayuda sobre {{topic}}",
            copyToClipboard: "Copiar {{label}} al portapapeles",
            previewMaterial: "Vista previa de {{title}}",
            ballotsTable: "Papeletas",
            ballotLocatorTabs: "Secciones del localizador de papeletas",
            ballotIdLabel: "ID de voto",
            votingProgress: "Progreso de la votación",
            stepOf: "Paso {{current}} de {{total}}",
            selectUpTo_one: "Seleccione hasta {{count}} opción",
            selectUpTo_many: "Seleccione hasta {{count}} opciones",
            selectUpTo_other: "Seleccione hasta {{count}} opciones",
            selectExactly_one: "Seleccione {{count}} opción",
            selectExactly_many: "Seleccione {{count}} opciones",
            selectExactly_other: "Seleccione {{count}} opciones",
            selectBetween: "Seleccione entre {{min}} y {{max}} opciones",
        },
        candidatesList: {
            collapseToggle: "Alternar lista {{listTitle}}",
            showCandidates: "Mostrar candidatos",
            hideCandidates: "Ocultar candidatos",
            selectedCandidates_one: "{{count}} candidato seleccionado",
            selectedCandidates_many: "{{count}} candidatos seleccionados",
            selectedCandidates_other: "{{count}} candidatos seleccionados",
            expandAll: "Expandir todo",
            collapseAll: "Contraer todo",
        },
        breadcrumbSteps: {
            electionList: "Lista de Votaciones",
            ballot: "Papeleta",
            review: "Revisión",
            confirmation: "Confirmación",
            audit: "Auditar",
        },
        footer: {
            poweredBy: "Funciona con <1></1>",
        },
        contest: {
            acclamation: {
                description: "Esta votación se ha resuelto por aclamación. Sus candidaturas resultan elegidas sin votación, por lo que no se puede seleccionar ninguna opción ni se registra ningún voto.",
            },
        },
        votingScreen: {
            backButton: "Atrás",
            reviewButton: "Siguiente",
            clearButton: "Limpiar selecciones",
            ballotHelpDialog: {
                title: "Información: Pantalla de votación",
                content: "Esta pantalla muestra las preguntas en las que usted es elegible para votar. Puede hacer su selección activando la casilla a la derecha del Candidato/Respuesta. Para restablecer sus selecciones, haga clic en el botón “<b>Limpiar selecciones</b>”, para pasar al siguiente paso, haga clic en el botón “<b>Siguiente</b>”.",
                ok: "OK",
            },
            nonVotedDialog: {
                title: "Voto inválido o en blanco",
                content: "Algunas de sus respuestas harán que la papeleta en una o más preguntas sea inválida o en blanco.",
                ok: "Volver y revisar",
                continue: "Continuar",
                cancel: "Cancelar",
            },
            warningDialog: {
                title: "Revise su papeleta",
                content: "Su papeleta contiene selecciones que pueden necesitar su atención (como seleccionar menos opciones de las permitidas). Su papeleta es válida y se contará tal como se ha enviado.",
                ok: "Volver y revisar",
                continue: "Continuar",
                cancel: "Cancelar",
            },
            blankBallotDialog: {
                title: "No ha seleccionado ningún candidato",
                content: "No ha realizado ninguna selección. Su papeleta se emitirá como papeleta en blanco, lo cual es una elección válida y deliberada y se contabilizará como tal.",
                continue: "Continuar",
                cancel: "Cancelar",
            },
        },
        startScreen: {
            startButton: "Empezar a votar",
            declineToVoteButton: "Declinar votar",
            declineToVoteDialog: {
                title: "Confirmar declinación de voto",
                content: "¿Está seguro de que desea declinar votar?<br />Irá directamente a la revisión y su estado de participación se guardará como <b>Ha declinado votar</b>.",
                continue: "Declinar votar",
                cancel: "Cancelar",
            },
            instructionsTitle: "Instrucciones",
            instructionsDescription: "Por favor, siga estos pasos para emitir su voto:",
            step1Title: "1. Haga sus selecciones",
            step1Description: "Seleccione sus candidatos preferidos y responda las preguntas de la elección una por una a medida que aparezcan. Puede editar su papeleta hasta que esté listo para continuar.",
            step2Title: "2. Revise su papeleta",
            step2Description: "Una vez que esté satisfecho con sus selecciones, encriptaremos su papeleta y le mostraremos una revisión final de sus selecciones. También recibirá un ID de seguimiento único para su papeleta.",
            step3Title: "3. Emita su papeleta",
            step3Description: "Envíe su papeleta: Finalmente, puede enviar su papeleta para que se registre correctamente. Alternativamente, puede optar por auditar y confirmar que su papeleta fue capturada y cifrada correctamente.",
        },
        reviewScreen: {
            acclamation: {
                title: "Resuelto por aclamación",
                helpDialog: {
                    title: "Información: Aclamación",
                    content: "Esta pantalla muestra lo que se ha resuelto por aclamación. Como no se ha podido seleccionar ninguna opción, no se emite ninguna papeleta y no hay nada que verificar después.",
                    ok: "OK",
                },
                description: "Revise lo que se ha resuelto por aclamación en esta elección. No se emitirá ninguna papeleta.",
                finishButton: "Finalizar",
            },
            title: "Revise su voto",
            description: "Para realizar cambios en sus selecciones, haga clic en el botón “<b>Editar su voto</b>”, para confirmar sus selecciones, haga clic en el botón “<b>Enviar voto</b>” debajo, y para auditar su papeleta haga clic en el botón “<b>Auditar papeleta</b>” debajo.",
            descriptionNoAudit: "Para realizar cambios en sus selecciones, haga clic en el botón “<b>Editar su voto</b>”, para confirmar sus selecciones, haga clic en el botón “<b>Enviar voto</b>” debajo.",
            backButton: "Editar su voto",
            castBallotButton: "Enviar voto",
            auditButton: "Auditar papeleta",
            copyBallotId: "Copiar el ID de la papeleta",
            ballotIdCopied: "ID de la papeleta copiado",
            ballotIdCopyError: "No se pudo copiar el ID de la papeleta",
            reviewScreenHelpDialog: {
                title: "Información: Pantalla de revisión",
                content: "Esta pantalla le permite revisar sus selecciones antes de emitir su voto.",
                ok: "OK",
            },
            ballotIdHelpDialog: {
                title: "Voto no emitido",
                content: "<p>Está a punto de copiar el Localizador del Voto, pero <b>su voto aún no se ha emitido</b>. Si intenta buscar el Localizador del Voto, no lo encontrará.</p><p>La razón por la que mostramos el Localizador del Voto en este momento es para que pueda auditar la corrección del voto cifrado antes de emitirlo. Si esa es la razón por la que desea copiar el Localizador del Voto, proceda a copiarlo y luego audite su voto.</p>",
                ok: "Acepto que mi voto NO ha sido emitido",
                cancel: "Cancelar",
            },
            auditBallotHelpDialog: {
                title: "¿Realmente quiere auditar su papeleta?",
                content: "<p>La auditoría de la papeleta lo invalidará y tendrá que iniciar el proceso de votación de nuevo si desea emitir su voto. El proceso de auditoría de la papeleta permite verificar que está codificada correctamente. Hacer este proceso requiere que unos conocimientos técnicos importantes, por lo que no se recomienda si no sabe lo que está haciendo.</p><p><b>Si lo que desea es emitir su voto, en <u>Cancelar</u> para volver a la pantalla de revisión de votación.</b></p>",
                ok: "Si, quiero INVALIDAR mi papeleta para AUDITARLA",
                cancel: "Cancelar",
            },
            confirmCastVoteDialog: {
                title: "¿Está seguro de que quiere emitir su voto?",
                content: "Su voto no se podrá editar una vez confirmado.",
                ok: "Sí, quiero EMITIR mi voto",
                cancel: "Cancelar",
            },
            confirmCastBlankBallotDialog: {
                title: "¿Está seguro de que desea emitir una papeleta en blanco?",
                content: "No ha seleccionado ningún candidato. Una vez confirme, su papeleta se emitirá en blanco.",
                ok: "Sí, quiero emitir mi papeleta en blanco",
                cancel: "Cancelar",
            },
            unfilledContestsDialog: {
                title: "Hay selecciones sin completar",
                content: "Puede dejar un cargo en blanco o seleccionar menos candidatos. Revise lo siguiente antes de continuar.",
                selected: "{{selected}} de {{max}} seleccionadas",
                nothingSelected: "Sin voto para este cargo",
                ok: "Continuar con estas selecciones",
                cancel: "Revisar selecciones",
            },
            error: {
                NETWORK_ERROR: "Hubo un problema de red. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                UNABLE_TO_FETCH_DATA: "Hubo un problema al recuperar los datos. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                LOAD_ELECTION_EVENT: "No se puede cargar el evento electoral. Por favor, inténtelo de nuevo más tarde.",
                CAST_VOTE: "Ha ocurrido un error desconocido al emitir el voto. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_CheckStatusFailed: "La elección no permite emitir el voto. La elección puede estar cerrada, archivada o quizá esté intentando votar fuera del período de gracia.",
                CAST_VOTE_AreaNotFound: "Ha ocurrido un error al emitir el voto: área no encontrada. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_InternalServerError: "Ha ocurrido un error interno al emitir el voto. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_QueueError: "Ha ocurrido un problema al procesar su voto. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_Unauthorized: "No está autorizado para emitir un voto. Por favor, contacte con el soporte para obtener ayuda.",
                CAST_VOTE_ElectionEventNotFound: "No se pudo encontrar el evento electoral. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_ElectoralLogNotFound: "No se pudo encontrar su registro de votación. Por favor, contacte con el soporte para obtener ayuda.",
                CAST_VOTE_CheckPreviousVotesFailed: "Ha ocurrido un error al verificar su estado de votación. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_GetClientCredentialsFailed: "No se pudieron verificar sus credenciales. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_GetAreaIdFailed: "Ha ocurrido un error al verificar su área de votación. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_GetTransactionFailed: "Ha ocurrido un error al procesar su voto. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_DeserializeBallotFailed: "Ha ocurrido un error al leer su papeleta. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_DeserializeContestsFailed: "Ha ocurrido un error al leer sus selecciones. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_PokValidationFailed: "No se pudo validar su voto. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_UuidParseFailed: "Ha ocurrido un error al procesar su solicitud. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_unexpected: "Ha ocurrido un error desconocido al emitir el voto. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_timeout: "Error de tiempo de espera al emitir el voto. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_InsertFailedExceedsAllowedRevotes: "Ha superado el límite de revotos. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_CheckRevotesFailed: "Ha superado el número permitido de revotos. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_CheckVotesInOtherAreasFailed: "Ya ha votado en otra área. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CAST_VOTE_UnknownError: "Ha ocurrido un error desconocido al emitir el voto. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                NO_BALLOT_SELECTION: "El estado de selección para esta elección no está presente. Asegúrese de haber seleccionado correctamente sus opciones o contacte con el soporte.",
                NO_BALLOT_STYLE: "El estilo de la papeleta no está disponible. Por favor, contacte con el soporte.",
                NO_AUDITABLE_BALLOT: "No hay una papeleta verificable disponible. Por favor, contacte con el soporte.",
                INCONSISTENT_HASH: "Hubo un error relacionado con el proceso de hash de la papeleta. El BallotId: {{ballotId}} no es coherente con el Hash de la Papeleta Verificable: {{auditableBallotHash}}. Por favor, informe de este problema al soporte.",
                ELECTION_EVENT_NOT_OPEN: "El evento electoral está cerrado. Por favor, contacte con el soporte.",
                PARSE_ERROR: "Hubo un error al analizar la papeleta. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                DESERIALIZE_AUDITABLE_ERROR: "Hubo un error al deserializar la papeleta verificable. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                DESERIALIZE_HASHABLE_ERROR: "Hubo un error al deserializar la papeleta hashable. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                CONVERT_ERROR: "Hubo un error al convertir la papeleta. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                SERIALIZE_ERROR: "Hubo un error al serializar la papeleta. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                UNKNOWN_ERROR: "Hubo un error. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                REAUTH_FAILED: "La autenticación ha fallado. Por favor, inténtelo de nuevo o contacte con el soporte para obtener ayuda.",
                SESSION_EXPIRED: "Su sesión ha expirado. Por favor, inténtelo de nuevo desde el principio.",
                CAST_VOTE_BallotIdMismatch: "El identificador de la papeleta no coincide con el del voto emitido.",
                CAST_VOTE_BallotStyleMismatch: "Su papeleta no coincide con la que está publicada actualmente para esta elección. Por favor, recargue la página e inténtelo de nuevo, o contacte con soporte para obtener ayuda.",
                SESSION_STORAGE_ERROR: "El almacenamiento de sesión no está disponible. Por favor, inténtelo de nuevo o contacte con el soporte.",
                PARSE_BALLOT_DATA_ERROR: "Hubo un error al analizar los datos de la papeleta. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                NOT_VALID_BALLOT_DATA_ERROR: "Los datos de la papeleta no son válidos. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                FETCH_DATA_TIMEOUT_ERROR: "Error de tiempo de espera al obtener los datos. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                TO_HASHABLE_BALLOT_ERROR: "Error al convertir a papeleta hashable. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                INTERNAL_ERROR: "Hubo un error interno al emitir el voto. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
            },
            declineToVote: "Declinar votar",
            blankBallot: "Papeleta en blanco",
        },
        confirmationScreen: {
            acclamation: {
                title: "Resuelto por aclamación",
                description: "Todas las votaciones de esta elección se han resuelto por aclamación, por lo que no se ha emitido ninguna papeleta y no hay identificador de papeleta que consultar.",
                helpDialog: {
                    title: "Información: Aclamación",
                    content: "Todas las votaciones de esta elección se han resuelto por aclamación: sus candidaturas resultan elegidas sin votación. Como no se ha emitido ninguna papeleta, no hay identificador de papeleta, comprobante ni código QR que verificar.",
                    ok: "OK",
                },
            },
            title: "Su voto ha sido emitido",
            description: "El código de confirmación que aparece a continuación verifica que <b>su voto se ha emitido correctamente</b>. Puede utilizar este código para verificar que su voto ha sido contabilizado.",
            blankBallot: {
                description: "Su papeleta se emitió en blanco, lo cual es una elección válida y deliberada.",
            },
            ballotId: "Localizador del Voto",
            printButton: "Imprimir",
            finishButton: "Finalizar",
            remainingElectionsError: "No pudimos comprobar si tiene más elecciones en las que votar. Vuelva a intentarlo.",
            retryButton: "Reintentar",
            verifyCastTitle: "Compruebe que su voto ha sido emitido",
            verifyCastDescription: "Puede comprobar en todo momento que su papeleta se ha emitido correctamente utilizando el siguiente código QR:",
            confirmationHelpDialog: {
                title: "Información: Pantalla de confirmación",
                content: "Esta pantalla muestra que su voto se ha emitido correctamente. La información proporcionada en esta página le permite verificar que la papeleta ha sido almacenada en la urna , este proceso puede ser ejecutado en cualquier momento durante el periodo de votación y después de que la elección haya sido cerrada.",
                ok: "OK",
            },
            demoPrintDialog: {
                title: "Impresión de la papeleta de votación",
                content: "La impresión está desactivada en modo de demostración",
                ok: "Aceptar",
            },
            demoBallotUrlDialog: {
                title: "Rastreador de Papeletas",
                content: "No se puede usar el código, deshabilitado en modo de demostración.",
                ok: "OK",
            },
            ballotIdHelpDialog: {
                title: "Información: Localizador del Voto",
                content: "El Localizador del Voto de papeleta es un código que le permite encontrar su papeleta en la urna, este Localizador es único y no contiene información sobre sus selecciones.",
                ok: "OK",
            },
            ballotIdDemoHelpDialog: {
                title: "Información: Identificación de la papeleta",
                content: "<p>La identificación de la papeleta es un código que le permite encontrar su papeleta en la urna. Este identificador es único y no contiene información sobre sus selecciones.</p><p><b>Aviso:</b> Esta cabina de votación es solo para fines de demostración. Su voto NO ha sido emitido.</p>",
                ok: "Aceptar",
            },
            errorDialogPrintBallotReceipt: {
                title: "Error",
                content: "Ha ocurrido un error. Por favor, inténtelo de nuevo.",
                ok: "Aceptar",
            },
            demoQRText: "El rastreador de papeletas está deshabilitado en modo de demostración",
        },
        auditScreen: {
            printButton: "Imprimir",
            restartButton: "Iniciar votación",
            title: "Audite su Papeleta",
            description: "Para verificar su papeleta deberá seguir los siguientes pasos:",
            step1Title: "1. Descargue o copie la siguiente información",
            step1Description: "Su <b>Localizador del Voto</b> que aparece en la parte superior de la pantalla y su papeleta encriptada a continuación:",
            step1HelpDialog: {
                title: "Copiar el Voto Cifrado",
                content: "Puede descargar o copiar su Voto Cifrado para auditarlo y verificar que el contenido encriptado contiene sus selecciones.",
                ok: "OK",
            },
            downloadButton: "Descargar",
            step2Title: "2. Verifique su papeleta",
            step2Description: "<VerifierLink>Acceda al verificador del voto</VerifierLink>, que se abrirá una nueva pestaña en su navegador.",
            step2HelpDialog: {
                title: "Tutorial sobre la Auditoría del Voto",
                content: "Para auditar su voto deberá seguir los pasos indicados en el tutorial, que incluyen la descarga de una aplicación de escritorio utilizada para verificar el voto cifrado independientemente del sitio web.",
                ok: "OK",
            },
            bottomWarning: "Por motivos de seguridad, cuando audite su papeleta, deberá invalidarla. Para continuar con el proceso de votación, haga clic en ‘<b>Iniciar votación</b>’.",
        },
        electionSelectionScreen: {
            title: "Lista de Votaciones",
            description: "Seleccione la votación que desea votar",
            chooserHelpDialog: {
                title: "Información: Lista de Votaciones",
                content: "Bienvenido a la cabina de votación, esta pantalla muestra la lista de elecciones en las que puede emitir su voto. Las elecciones que aparecen en esta lista pueden estar abiertas a votación, programadas o cerradas. Sólo podrá acceder a la votación si el periodo de votación está abierto.",
                ok: "OK",
            },
            noResults: "No hay elecciones por ahora.",
            resultsButton: "Ver resultados",
            demoDialog: {
                title: "Cabina de votación de demostración",
                content: "Está entrando en una cabina de votación de demostración. <strong>Su voto NO será registrado.</strong> Esta cabina de votación es solo para fines de demostración.",
                ok: "Acepto que mi voto NO será registrado",
            },
            errors: {
                noVotingArea: "Área electoral no asignada al votante. Por favor, inténtelo de nuevo más tarde o contacte con soporte para obtener ayuda.",
                networkError: "Hubo un problema de red. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                unableToFetchData: "Hubo un problema al obtener los datos. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                noElectionEvent: "El evento electoral no existe. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                ballotStylesEmlError: "Hubo un error con la publicación del estilo de la papeleta. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                obtainingElectionFromID: "Hubo un error al obtener las elecciones asociadas con los siguientes IDs de elecciones: {{electionIds}}. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
            },
            alerts: {
                noElections: "No hay elecciones en las que pueda votar. Esto podría deberse a que el área no tiene ninguna pregunta asociada. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
                electionEventNotPublished: "El evento electoral aún no ha sido publicado. Por favor, inténtelo de nuevo más tarde o contacte con el soporte para obtener ayuda.",
            },
            materialsGate: {
                instructions: "Debe leer <MaterialsLink>{{materialsTitle}}</MaterialsLink> antes de poder votar.",
            },
        },
        errors: {
            page: {
                oopsWithStatus: "¡Vaya! {{status}}",
                oopsWithoutStatus: "¡Vaya! Error Inesperado",
                somethingWrong: "Algo salió mal.",
                invalidLoginHintParametersTitle: "Enlace de votación no válido",
                invalidLoginHintParametersMessage: "Este enlace de votación contiene información de acceso no válida. Solicite un nuevo enlace e inténtelo de nuevo.",
                certAuthFailedTitle: "Error de Autenticación con Certificado",
                certAuthFailedMessage: "No se ha podido verificar su certificado. Compruebe que está usando un certificado de votante válido e inténtelo de nuevo.",
            },
        },
        materials: {
            common: {
                label: "Materiales de Soporte",
                back: "Volver a la Lista de Votaciones",
                close: "Cerrar",
                preview: "Vista previa",
                download: "Descargar",
            },
            mandatory: {
                checkboxLabel: "He leído los Materiales de Soporte",
                continueButton: "Continuar",
                error: "Hubo un problema al registrar su confirmación. Por favor, inténtelo de nuevo.",
            },
        },
        slates: {
            title: "Candidaturas conjuntas",
            independent: "Independiente",
            contestMembers: "Candidatos de {{slate}} para {{contest}}",
            noCandidate: "Sin candidato",
            note: "Una lista selecciona sus candidatos y deja en blanco los cargos en los que no tiene candidato. Puedes cambiar cualquier opción individual en cualquier momento.",
            coverage: {
                full: "Candidatura completa",
                singleContest: "Solo {{contest}}",
                partial: "Candidatura parcial",
                everyOffice: "Candidatos para todos los cargos.",
                someOffices: "Candidatos para {{offices}}. Los demás cargos quedan en blanco.",
                candidates_one: "{{count}} candidato",
                candidates_other: "{{count}} candidatos",
                offices_one: "{{count}} cargo",
                offices_other: "{{count}} cargos",
            },
            candidateList: {
                show: "Mostrar candidatos",
                hide: "Ocultar candidatos",
            },
            tabs: {
                label: "Forma de selección",
                slates: "Elegir una lista",
                candidates: "Candidaturas individuales",
            },
            count: {
                short: "{{selected}} / {{seats}} candidatos seleccionados",
                long: "· {{selected}} de {{seats}} candidatos seleccionados",
                individual: "Selecciones individuales",
                none: "Ningún candidato seleccionado",
            },
            allSelections: {
                label: "Tus selecciones actuales",
                none: "Sin selección",
            },
            review: {
                title: "Tus selecciones",
                of: "de {{seats}}",
                selected: "Candidatos seleccionados",
                note: "Tu voto se registra para cada candidato seleccionado.",
                contestCount: "{{selected}} de {{max}} seleccionados",
                unfilled: "Ningún candidato seleccionado",
                editLabel: "Editar {{contest}}",
            },
            selection: {
                all: "Los {{total}} seleccionados",
                mixed: "Mixta · {{selected}} de {{total}} seleccionados",
                partly: "Seleccionada en parte · {{selected}} de {{total}}",
                selected: "Seleccionado",
                edit: "Editar selecciones",
            },
            apply: {
                button: "Seleccionar lista",
                buttonLabel: "Seleccionar la lista {{slate}}",
                applied: "{{slate}} seleccionada. Aún puedes cambiar cualquier candidato.",
                appliedPartial_one: "{{slate}} seleccionada. No tiene candidato para {{offices}}, así que ese cargo queda en blanco. Aún puedes cambiar cualquier candidato.",
                appliedPartial_other: "{{slate}} seleccionada. No tiene candidato para {{offices}}, así que esos cargos quedan en blanco. Aún puedes cambiar cualquier candidato.",
                overMaximum: "{{slate}} no se puede seleccionar: tiene {{candidates}} candidatos para {{contest}}, que permite {{max}}. Puedes seguir eligiendo candidatos individualmente.",
                unavailable: "{{slate}} no se puede seleccionar en esta papeleta. Puedes seguir eligiendo candidatos individualmente.",
                replaceDialog: {
                    title: "¿Reemplazar estas selecciones?",
                    content_one: "Seleccionar <strong>{{slate}}</strong> cambiará el siguiente cargo.",
                    content_other: "Seleccionar <strong>{{slate}}</strong> cambiará los siguientes cargos.",
                    current: "Selecciones actuales",
                    blankNote: "{{slate}} no tiene candidato para algunos cargos. Esos cargos quedarán en blanco.",
                    ok: "Reemplazar selecciones",
                    okOffice: "Reemplazar {{office}}",
                    cancel: "Mantener mis selecciones",
                },
            },
            clear: {
                cleared: "Se han borrado todas tus opciones.",
                dialog: {
                    title: "¿Borrar todas tus opciones?",
                    content: "Borrar quita todas las opciones de tu papeleta. Estos cargos cambian:",
                    after: "Después de borrar",
                    ok: "Borrar opciones",
                    cancel: "Mantener mis opciones",
                },
            },
            offices: {
                label: "Cargos",
                picker: "Cargo",
                index: "Cargo {{index}} de {{total}}",
                count: "{{selected}}/{{max}}",
                previous: "Cargo anterior",
                next: "Cargo siguiente",
                last: "Último cargo",
                instruction_one: "Selecciona hasta {{count}} candidato. {{selected}} seleccionados.",
                instruction_other: "Selecciona hasta {{count}} candidatos. {{selected}} seleccionados.",
            },
            limit: "Puedes seleccionar hasta {{count}}. Quita un candidato antes de elegir otro.",
            view: {
                button: "Ver lista",
                buttonLabel: "Ver la lista {{slate}}",
                summary: "{{coverage}} · {{candidates}}",
                select: "Seleccionar esta lista",
                back: "Volver",
            },
            dialog: {
                close: "Cerrar el diálogo",
            },
            clearContest: {
                button: "Borrar",
                label: "Borrar {{contest}}",
                cleared: "Selecciones borradas para {{contest}}.",
            },
        },
        ballotLocator: {
            title: "Encuentre su papeleta",
            titleResult: "Resultados de su búsqueda de Papeleta",
            description: "Confirme que su papeleta fue emitida correctamente",
            locate: "Encuentre su papeleta",
            locateAgain: "Encuentre otra papeleta",
            found: "Su ID de Papeleta {{ballotId}} ha sido encontrado",
            notFound: "Su ID de Papeleta {{ballotId}} no fue encontrado",
            ambiguous: "Más de una de sus papeletas coincide con {{ballotId}}. Use el ID de papeleta completo.",
            contentDesc: "Este es el contenido de su papeleta: ",
            wrongFormatBallotId: "Formato incorrecto para el ID de la Papeleta",
            ballotIdNotFoundAtFilter: "No encontrado, compruebe que el ID de la papeleta sea correcto y pertenezca a este usuario.",
            filterByBallotId: "Filtrar por ID de Papeleta",
            totalBallots: "Papeletas: {{total}}",
            steps: {
                lookup: "Encuentre su papeleta",
                result: "Resultado",
            },
            titleHelpDialog: {
                title: "Información: pantalla de Localización de su Papeleta",
                content: "Esta pantalla le permite al votante encontrar su Papeleta utilizando el ID de la Papeleta para recuperarlo. Este procedimiento permite comprobar que su voto fue emitido correctamente y que el voto registrado coincide con el voto cifrado que emitió.",
                ok: "OK",
            },
            tabs: {
                logs: "Logs",
                ballotLocator: "Localizador de Papeletas",
            },
            column: {
                statement_kind: "Tipo",
                statement_timestamp: "Marca de tiempo",
                username: "Usuario",
                ballot_id: "ID de Papeleta",
                message: "Mensaje",
            },
            pagination: {
                rowsPerPage: "Filas por página:",
                displayedRows: "{{from}}–{{to}} de {{total}}",
                displayedRowsMoreThan: "{{from}}–{{to}} de más de {{to}}",
                firstPage: "Ir a la primera página",
                lastPage: "Ir a la última página",
                nextPage: "Ir a la página siguiente",
                previousPage: "Ir a la página anterior",
            },
        },
    },
};
export default spanishTranslation;
